import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "row align-items-center" }
const _hoisted_5 = { class: "col-lg-8" }
const _hoisted_6 = {
  key: 0,
  class: "title mb-2"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "fa fa-bookmark fa-w-12 mr-1 text-warning" }, null, -1)
const _hoisted_8 = { class: "col-lg-4" }
const _hoisted_9 = { class: "text-lg-right" }
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fa fa-copy mr-2" }, null, -1)
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "row align-items-center" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "input-btn" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "inline-items inline-date-display text-md-right align-middle" }
const _hoisted_17 = { for: "" }
const _hoisted_18 = { for: "" }
const _hoisted_19 = /*#__PURE__*/_createVNode("i", { class: "fas fa-sync-alt" }, null, -1)
const _hoisted_20 = { class: "card" }
const _hoisted_21 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_22 = { class: "badge badge-success rounded" }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_25 = {
  key: 2,
  class: "check-wrap my-2"
}
const _hoisted_26 = { class: "row align-items-center" }
const _hoisted_27 = { class: "col-6" }
const _hoisted_28 = {
  key: 0,
  class: "form-group mb-0"
}
const _hoisted_29 = { class: "mb-0" }
const _hoisted_30 = {
  key: 0,
  class: "col-6"
}
const _hoisted_31 = { class: "text-lg-right mb-0" }
const _hoisted_32 = /*#__PURE__*/_createVNode("i", { class: "fa fa-share" }, null, -1)
const _hoisted_33 = {
  key: 3,
  class: "row mx-n2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToDoListBreadCrumb = _resolveComponent("ToDoListBreadCrumb")
  const _component_AppGoBack = _resolveComponent("AppGoBack")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ToDoListPhaseBlock = _resolveComponent("ToDoListPhaseBlock")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_ToDoListAddPhaseModal = _resolveComponent("ToDoListAddPhaseModal")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getToDoData && !_ctx.state.data.showGetToDoList)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_ctx.todoData.project && _ctx.todoData.project.name)
            ? (_openBlock(), _createBlock("h1", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.todoData.project.name), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ToDoListBreadCrumb, {
            project: _ctx.todoData.project,
            breadCrumbEndPoint: _ctx.state.data.endPoint
          }, null, 8, ["project", "breadCrumbEndPoint"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("a", {
              class: "btn default-btn outline mr-2",
              href: "javascript:void(0)",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copySharableLink && _ctx.copySharableLink(...args)))
            }, [
              _hoisted_10,
              _createTextVNode(_toDisplayString(_ctx.$t('copy')), 1)
            ]),
            _createVNode(_component_AppGoBack, {
              uuid: _ctx.todoData.project.uuid,
              pathName: `smart-contract-list`
            }, null, 8, ["uuid"])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ErrorList, {
      errors: _ctx.state.ui.error.errorList.getToDoData,
      hasError: _ctx.state.ui.error.hasError
    }, null, 8, ["errors", "hasError"]),
    _createVNode("div", _hoisted_11, [
      _createVNode("div", _hoisted_12, [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _withDirectives(_createVNode("input", {
              id: "searchTemplateByText",
              type: "text",
              class: "form-control",
              placeholder: `Search form eg.Kitchen forms, etc related to Project: ${_ctx.todoData.project.name}`,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.todoFilterBy.search = $event)),
              autocomplete: "off",
              onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getToDoDataBySearch && _ctx.getToDoDataBySearch(...args))),
              onKeydown: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.getToDoDataBySearch && _ctx.getToDoDataBySearch(...args)), ["enter"]))
            }, null, 40, ["placeholder"]), [
              [_vModelText, _ctx.state.data.todoFilterBy.search]
            ]),
            _createVNode("a", {
              href: "javascript:void(0)",
              class: "btn default-btn",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getToDoDataBySearch && _ctx.getToDoDataBySearch(...args)))
            }, _toDisplayString(_ctx.$t('search')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_15, [
          _createVNode("div", _hoisted_16, [
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('from')), 1)
              ]),
              _createVNode("li", null, [
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.todoFilterBy.startDate = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.todoFilterBy.startDate]
                ])
              ]),
              _createVNode("li", null, [
                _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('to')), 1)
              ]),
              _createVNode("li", null, [
                _withDirectives(_createVNode("input", {
                  type: "date",
                  class: "form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.todoFilterBy.endDate = $event))
                }, null, 512), [
                  [_vModelText, _ctx.state.data.todoFilterBy.endDate]
                ])
              ]),
              _createVNode("li", null, [
                _createVNode("button", {
                  id: "clearTodoList",
                  class: "add-templete-btn",
                  title: "clear",
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.clearGetToDoData && _ctx.clearGetToDoData(...args)))
                }, [
                  _hoisted_19
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_20, [
      (_ctx.todoData.phases.data && _ctx.todoData.phases.data.length)
        ? (_openBlock(), _createBlock("p", _hoisted_21, [
            _createVNode("strong", null, [
              _createTextVNode(_toDisplayString(_ctx.$t('you_have_total')) + " ", 1),
              _createVNode("span", _hoisted_22, _toDisplayString(_ctx.todoData.phases.data.length), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('phase')), 1)
            ])
          ]))
        : (_openBlock(), _createBlock("p", _hoisted_23, [
            _createVNode("strong", null, _toDisplayString(_ctx.$t('you_dont_have_any_phases')), 1)
          ])),
      _hoisted_24,
      (_ctx.todoData.phases.data && _ctx.todoData.phases.data.length)
        ? (_openBlock(), _createBlock("div", _hoisted_25, [
            _createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                (_ctx.todoData.role === 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_28, [
                      _createVNode("label", _hoisted_29, [
                        _withDirectives(_createVNode("input", {
                          type: "checkbox",
                          id: "checkbox",
                          name: "checkbox1",
                          value: "1",
                          class: "align-middle mr-2",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectAll = $event)),
                          onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.checkAllStatus && _ctx.checkAllStatus(...args))),
                          disabled: _ctx.state.data.totalReadyToCheck.length == 0
                        }, null, 40, ["disabled"]), [
                          [_vModelCheckbox, _ctx.selectAll]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('select_all')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.todoData.role === 1)
                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                    _createVNode("div", _hoisted_31, [
                      _createVNode("button", {
                        class: "btn default-btn d-inline-block",
                        disabled: !_ctx.state.ui.isLoading.showShareEstimation,
                        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.sendEstimationInvitation && _ctx.sendEstimationInvitation(...args)))
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('send_estimation')) + " ", 1),
                        _hoisted_32
                      ], 8, ["disabled"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (
          _ctx.todoData.phases && _ctx.todoData.phases.data && _ctx.todoData.phases.data.length
        )
        ? (_openBlock(), _createBlock("div", _hoisted_33, [
            (
            _ctx.todoData.phases &&
            _ctx.todoData.phases.data &&
            _ctx.todoData.phases.data.length
          )
              ? (_openBlock(), _createBlock(_component_ToDoListPhaseBlock, {
                  key: 0,
                  phases: _ctx.todoData.phases.data,
                  project: _ctx.todoData.project,
                  role: _ctx.todoData.role,
                  details: 
            _ctx.todoData.projectAcknowledgement
              ? _ctx.todoData.projectAcknowledgement.payerRequest
              : ''
          ,
                  onAddPhase: _ctx.addNewPhase,
                  onUpdateCheckSelectPhase: _ctx.updateCheckSelectPhase,
                  onUpdatePhaseList: _ctx.updatePhaseList
                }, null, 8, ["phases", "project", "role", "details", "onAddPhase", "onUpdateCheckSelectPhase", "onUpdatePhaseList"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock(_component_EmptyData, {
            key: 4,
            title: _ctx.state.data.todoEmptyTitle,
            heading: _ctx.state.data.todoEmptyDescription
          }, null, 8, ["title", "heading"]))
    ]),
    (_ctx.state.data.showAddPhaseModal)
      ? (_openBlock(), _createBlock(_component_ToDoListAddPhaseModal, {
          key: 1,
          editMode: _ctx.state.data.editMode,
          editFrom: 'createPhase',
          projectDetail: _ctx.todoData.project,
          projectAcknowledgementDetail: 
        _ctx.todoData.projectAcknowledgement.payerRequest
      ,
          todoDetail: _ctx.todoData.todo,
          phase: _ctx.todoData.phases.data,
          showAddPhase: _ctx.state.data.showAddPhaseModal,
          modelName: 'phase',
          onCheck: _ctx.check,
          onClose: _ctx.showAddPhaseModal,
          onAddPhase: _ctx.addNewPhase
        }, null, 8, ["editMode", "projectDetail", "projectAcknowledgementDetail", "todoDetail", "phase", "showAddPhase", "onCheck", "onClose", "onAddPhase"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 2,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFullMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ]))
}